import { makeStyles } from '@material-ui/core'

const styles = ({ primaryColor, secondaryColor, secondaryTextColor }) =>
  makeStyles((theme) => ({
    wrapper: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
    },
    header: {
      backgroundColor: primaryColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
    },
    titleBox: {
      backgroundColor: secondaryColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
    },
    titleText: {
      color: secondaryTextColor,
      textAlign: 'center',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
    },
    companyLogo: {
      backgroundColor: secondaryColor,
      borderRadius: theme.shape.borderRadius,
    },
    attendanceCard: {
      backgroundColor: secondaryColor,
      cursor: 'pointer',
      borderRadius: theme.shape.borderRadius,
    },
    attendanceCardText: {
      color: secondaryTextColor,
      textAlign: 'center',
      textTransform: 'uppercase',
      fontWeight: 500,
      wordBreak: 'break-word',
    },
    policiesTitle: {
      fontWeight: 700,
    },
    policyCard: {
      border: `1px solid ${secondaryColor}`,
      cursor: 'pointer',
      borderRadius: theme.shape.borderRadius,
    },
    policyCardText: {
      color: secondaryColor,
      textAlign: 'center',
      textTransform: 'uppercase',
      fontWeight: 500,
      wordBreak: 'break-word',
    },
  }))

export default styles
